const decimal = 4
const kaaba = { lat: 21.422493.toFixed(decimal), lng: 39.826202.toFixed(decimal) }
const configs = {
        decimal: decimal,
        kaaba : kaaba,
        zoomLevel: 18
    }
export default configs